// @flow

import { useRef } from 'react';

let currentId = 0;

export function useUniqueId(): string {
  const uniqueIdRef = useRef(null);
  if (uniqueIdRef.current === null) {
    uniqueIdRef.current = ++currentId;
  }

  return `tectonics-id-${uniqueIdRef.current}`;
}
